import React from "react";

import "./CartItem.scss";

import deleteBtn from "../../images/icon/icon-delete.svg";
import minusBtn from "../../images/icon/icon-minus.svg";
import plusBtn from "../../images/icon/icon-plus.svg";

const CartItem = ({ item, add, sub, del }) => {
  function getNumberFormat(price) {
    return new Intl.NumberFormat("en-US").format(price);
  }

  return (
    <div className="cart-item">
      <div className="upper-area">
        <p>{item.pluNm}</p>
        <img src={deleteBtn} alt="cart-delete" onClick={() => del(item)} />
      </div>
      <div className="lower-area">
        <p>{getNumberFormat(item.totAmt)}원</p>
        <div className="cart-item-qty">
          {item.qty > 1 ? (
            <img src={minusBtn} alt="qty-minus" onClick={() => sub(item)} />
          ) : (
            <img className="minus-inactive" src={minusBtn} alt="qty-minus" />
          )}
          <p>{item.qty}</p>
          <img src={plusBtn} alt="qty-plus" onClick={() => add(item)} />
        </div>
      </div>
    </div>
  );
};

export default CartItem;
